import { Card, RequestCard, Timeline } from '@/ds'
import { dayMonthTime } from '@/lib/format'
import type { GuestRequest } from '@/services/peticiones'
import { useLang } from './shared'

/**
 * Seguimiento de una petición de cambio (Bloque 5 §5g: "petición con seguimiento"). Solo lectura: la vista
 * completa de peticiones, con comentarios, es del bloque 6. Tarjeta de petición y línea de tiempo (DESIGN.md §4).
 */
export function RequestTracking({ request, compact }: { request: GuestRequest; compact?: boolean }) {
  const { t, lang } = useLang()
  const title = request.changeType ? t(`v2.reserva.peticiones.tipo.${request.changeType}`) : t('v2.reserva.peticiones.tipo.generica')
  return (
    <Card>
      <RequestCard title={title} status={request.status} date={t('v2.reserva.peticiones.enviada', { when: dayMonthTime(request.createdAt, lang) })} className="reserva__request" />
      <p className="reserva__request-text">{request.text}</p>
      {!compact && (
        <Timeline
          items={request.timeline.map((m) => ({
            id: m.code,
            state: m.state,
            title: t(`v2.peticiones.seguimiento.hito.${m.code}`),
            ...(m.date ? { date: dayMonthTime(m.date, lang) } : m.code === 'progress' && request.responseWithinHours ? { date: t('v2.reserva.peticiones.plazo', { count: request.responseWithinHours }) } : {}),
            ...(m.note ? { description: m.note } : {}),
          }))}
        />
      )}
    </Card>
  )
}
